import { Component, OnInit, Input, Output, EventEmitter, OnDestroy  } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { CustomerSupplierService } from '../../services/customer-supplier.service';
import { SubsidiaryService } from '../../services/subsidiary.service';
import { CustomerSupplierTypeService } from '../../services/customer-supplier-type.service';

import { Utils } from '../../util';
import { Subscription } from 'rxjs';
import { toast } from 'angular2-materialize';

@Component({
	selector: 'app-create-customer',
	templateUrl: './create-customer.component.html',
	styleUrls: ['./create-customer.component.css', '../../app.component.css']
})

export class CreateCustomerComponent implements OnInit, OnDestroy {

	customerForm: FormGroup;
	customer: any;

	pickadateParams = Utils.pickadateParams();

	subsidiaries = {};
	subsidiaryInit: any;
	subsidiaryText = '';

	types: any[] = [];
	@Input() typeInit: string;
	@Output() typeModelChange = new EventEmitter();

	sub: Subscription;

	constructor(
		private formBuilder: FormBuilder,
		private router: Router,
		private customerSupplierService: CustomerSupplierService,
		private subsidiaryService: SubsidiaryService,
		private customerSupplierTypeService: CustomerSupplierTypeService
	) {
		this.loadSubsidiariesAndTypes();
	}

	ngOnInit() {
		this.customerForm = this.formBuilder.group({
			name: ['', Validators.required],
			initials: '',
			description: ['', Validators.required],
			email: ['', [Validators.required, Validators.email]],
			clientSince: '',
			subsidiary: ['', Validators.required],
			type: ['', Validators.required],
			nextProduct: 0,
			nextSuaje: 0,
		});
	}
	ngOnDestroy(){
		this.sub.unsubscribe();
	}

	onSubmitCustomer() {
		this.customer = this.saveCustomer();
		console.log('entro submit');
		let sub = this.customerSupplierService.getCustomerByInitials(Utils.initials(this.customer.initials), ()=>{
			//onEmpty
			this.customerSupplierService.postCustomerSupplier(this.customer);
		}, ()=>{
			//onNotEmpty
			toast('Esas iniciales ya están utilizadas.', 3000);
		}).subscribe(u => { sub.unsubscribe(); })

	}

	saveCustomer() {
		let clientSince: any;
		if (this.customerForm.get('clientSince').value) {
			clientSince = Utils.convertDatefromISOStringtoObject(this.customerForm.get('clientSince').value);
		} else {
			clientSince = '';
		}

		const currentDate = new Date();

		var initials = this.customerForm.get('initials').value.toUpperCase();
		initials = initials.length > 2 ? initials.charAt(0) + initials.charAt(1) : initials.length == 1 ? `0${initials}` : initials ? initials : '00';

		const customerJson = {
			active: 1,
			clientSince: clientSince,
			createdAt: currentDate,
			description: this.customerForm.get('description').value,
			email: this.customerForm.get('email').value,
			name: this.customerForm.get('name').value,
			initials,
			nextProduct: +this.customerForm.get('nextProduct').value || 0,
			nextSuaje: +this.customerForm.get('nextSuaje').value || 0,
			subsidiaryId: this.subsidiaries[this.customerForm.get('subsidiary').value],
			typeId: this.customerForm.get('type').value,
			updatedAt: currentDate
		};

		return customerJson;
	}

	loadSubsidiariesAndTypes() {
		this.sub = this.subsidiaryService.getSubsidiaries().subscribe(tempSubsidiaries => {
			const data = {};
			
			if(tempSubsidiaries.length == 1) this.customerForm.get('subsidiary').patchValue(tempSubsidiaries[0].name);

			for (const idx in tempSubsidiaries) {
				data[tempSubsidiaries[idx].name] = null;

				this.subsidiaries[tempSubsidiaries[idx].name] = tempSubsidiaries[idx].id$;
			}

			this.subsidiaryInit = {
				'data': data,
				onAutocomplete: (val) => {
					// console.log(val);
					// console.log(this.subsidiaries[val]);
				}
			};
		});

		let subType = this.customerSupplierTypeService.getCustomerTypes().subscribe(tempTypes => {
			for (const idx in tempTypes) {
				this.types.push(tempTypes[idx]);
			}

			this.typeInit = '1';

			subType.unsubscribe();
		});
	}

	onBlurSubsidiary() {
		if (this.subsidiaries[this.subsidiaryText] === undefined) {
			this.subsidiaryText = '';
		}
	}

	changeType(typeValue) {
		this.typeModelChange.emit(typeValue);
	}

}
